import { render, staticRenderFns } from "./CommandList.vue?vue&type=template&id=6816251a"
import script from "./CommandList.vue?vue&type=script&lang=js"
export * from "./CommandList.vue?vue&type=script&lang=js"
import style0 from "./CommandList.vue?vue&type=style&index=0&id=6816251a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports